export const MUT_SET_MARKS_RECORDS = 'MUT_SET_MARKS_RECORDS';
export const MUT_SET_MARK_RECORD_DETAILS = 'MUT_SET_MARK_RECORD_DETAILS';
export const MUT_SET_ERROR = 'MUT_SET_ERROR';
